/**
 * About page parallax driver — founder-only.
 *
 * Collage images use Sleek's native `<parallax-element>` (see `theme.js` `Parallax` class), matching
 * `sections/image-with-text.liquid`. This file only drives the founder section: transforms must apply
 * to `.about-founder__parallax-target` (the wrapper), NOT the <img>, to avoid the bitmap stacking-context
 * bug that paints over the overlapping Orleans name.
 *
 * Scroll progress model (founder)
 *   progress = clamp((vh - rect.top) / (vh + rect.height), 0, 1)
 *     0 = wrap top at viewport bottom (just entering)
 *     1 = wrap bottom at viewport top (just leaving)
 *   Mirrors Motion One's `offset: ['start end', 'end start']`.
 */
(function () {
  'use strict';

  if (window.__bmAboutParallaxTranslateBound) return;
  window.__bmAboutParallaxTranslateBound = true;

  var FOUNDER_AMPLITUDE = 80;
  /** Must stay inside the 1.08 cover buffer applied to the founder img in bm-overrides.css. */
  var FOUNDER_MAX_SHIFT_PX = 30;
  var FOUNDER_MAX_ZOOM_EXTRA = 0.09;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function clearTransform(el) {
    if (!el) return;
    el.style.transform = '';
    el.style.transformOrigin = '';
    el.style.willChange = '';
  }

  function getProgress(rect, vh) {
    var denom = vh + rect.height;
    if (denom <= 0) return 0;
    return clamp((vh - rect.top) / denom, 0, 1);
  }

  /* ---------------------------- Founder ---------------------------- */

  function clearFounderMediaTransforms(wrap) {
    var nodes = wrap.querySelectorAll('.about-founder__photo-img, .about-founder__parallax-target svg');
    for (var j = 0; j < nodes.length; j++) {
      clearTransform(nodes[j]);
    }
  }

  function updateFounder(reduce, vh) {
    var wraps = document.querySelectorAll('.about-founder [data-bm-scroll-parallax]');
    if (!wraps.length) return;

    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var target = wrap.querySelector('.about-founder__parallax-target');
      if (!target) continue;

      var speed = parseFloat(wrap.getAttribute('data-bm-scroll-parallax'));

      if (reduce || !Number.isFinite(speed) || speed <= 0) {
        clearTransform(target);
        clearFounderMediaTransforms(wrap);
        continue;
      }

      clearFounderMediaTransforms(wrap);

      var rect = wrap.getBoundingClientRect();
      var progress = getProgress(rect, vh);
      var centred = progress - 0.5;
      var axis = wrap.getAttribute('data-bm-parallax-axis') || 'y';

      if (axis === 'zoom') {
        var extra = clamp(progress * speed * 0.16, 0, FOUNDER_MAX_ZOOM_EXTRA);
        target.style.transform = 'scale(' + (1 + extra).toFixed(4) + ')';
        target.style.transformOrigin = 'center center';
      } else {
        var shift = clamp(-centred * speed * FOUNDER_AMPLITUDE * 2, -FOUNDER_MAX_SHIFT_PX, FOUNDER_MAX_SHIFT_PX);
        if (axis === 'x') {
          target.style.transform = 'translate3d(' + shift.toFixed(2) + 'px,0,0)';
        } else {
          target.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
        }
        target.style.transformOrigin = '';
      }
      target.style.willChange = 'transform';
    }
  }

  /* ---------------------------- Scheduler ---------------------------- */

  function update() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;

    updateFounder(reduce, vh);
  }

  var ticking = false;
  function onFrame() {
    ticking = false;
    update();
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onFrame);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  requestAnimationFrame(function () {
    requestAnimationFrame(schedule);
  });

  /* Help Motion One recompute scroll timelines after images/layout settle (all About pages with collage). */
  window.addEventListener(
    'load',
    function () {
      if (!document.querySelector('.about-image-collage')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      });
    },
    { once: true }
  );
})();
